var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomLlm({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 6.5,
    width: 11,
    height: 11,
    rx: 2.5,
    stroke: "#5b6b7c",
    strokeWidth: 1.6
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.25,
    y: 9.25,
    width: 5.5,
    height: 5.5,
    rx: 1.2,
    fill: "#4880FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 4.5v2M12 4.5v2M15 4.5v2M9 17.5v2M12 17.5v2M15 17.5v2M4.5 9h2M4.5 12h2M4.5 15h2M17.5 9h2M17.5 12h2M17.5 15h2",
    stroke: "#5b6b7c",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomLlm);
export default __webpack_public_path__ + "static/media/custom-llm.878a1112802cfc593391c7212bc580ca.svg";
export { ForwardRef as ReactComponent };